
<template>
  <div>
    {{ /*START HEADER */ }}
      <div>
        <b-navbar id="navbar_" ref="navbar_" toggleable="lg" type="dark" variant="danger" >
          <span id="coin_cont" href="#" > <img src="logo.png" id="coin"/></span>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" class="container" is-nav >
            <b-navbar-nav>
                <h4 class="header_title">Sezioni</h4>
                <span id="header_pages_cont" >
                  <button id="home_btn" class="header_btn" v-on:click="(e)=>{this.target_page='Home'}">Home</button>
                  <button id="servizi_btn" class="header_btn"  v-on:click="(e)=>{this.target_page='Servizi'}">Servizi</button>
                  <button id="eventi_btn" class="header_btn" v-on:click="(e)=>{this.target_page='Eventi'}">Eventi</button>
                  <button id="prodotti_btn" class="header_btn" v-on:click="(e)=>{this.target_page='Prodotti'}">Prodotti</button>
                  <button id="preferiti_btn" class="header_btn" v-on:click="(e)=>{this.target_page='Preferiti'}">Preferiti</button>
                  <button  ref="header_btn" id="team_btn" class="header_btn" v-on:click="(e)=>{this.target_page='Team'}">Team</button>
                  <button id="contatti_btn" class="header_btn" v-on:click="(e)=>{this.target_page='Contatti'}">Contatti</button>


                </span>  
                
                <div id="header_social_cont">
                  <b-nav-item href="https://instagram.com/hula_hoop_corato?utm_source=qr&igshid=YzU1NGVlODEzOA==" target="_blank"><font-awesome-icon :icon="`fa-brands fa-instagram`"/></b-nav-item>
                  <b-nav-item href="https://www.facebook.com/hulahoop.corato"  target="_blank"><font-awesome-icon :icon="`fa-brands fa-facebook`"/></b-nav-item>
                  <b-nav-item href="https://www.tiktok.com/@hula_hoop_corato?_t=8fskq1IbV7Q&_r=1"  target="_blank"><font-awesome-icon :icon="`fa-brands fa-tiktok`"/></b-nav-item>
                </div>
            </b-navbar-nav>
          </b-collapse>

        </b-navbar>
      </div>
      {{ /*END HEADER */ }}

    <div  v-if="show_page===false" style="text-align: center;font-size:16px" >
     
    <h1 style="color:red">Attenzione!</h1>
    <p>Hai aperto il sito in Samsung Browser.</p>
    <p style="color:red;font-weight: bold;">La modalità dark è problmatica solo su Samsung Browser.</p>
    <b-container>
      <b-row>
        <b-col>Sbagliato</b-col>
        <b-col>Giusto</b-col>
      </b-row>
      <b-row>
        <b-col><img src="coin_preview_wrong.jpg" style="width: 142px;height:134px"></b-col>
        <b-col><img src="coin_preview.png"></b-col>
      </b-row>
    </b-container>
    <br>
    <p>Se il logo è di colore nero allora segui una delle due soluzioni riportate di seguito.</p>
    <p>Altrimenti, se il logo è bianco, clicca sul seguente pulsante per procedere.</p>
    <b-button variant="danger" @click="handle_coin_disabled">Vai al sito!</b-button>
    <hr>
    <h1  style="color:red">Soluzioni!</h1>
    <p>Hai <span style="color:red;font-weight: bold;">due possibilità</span> per risolvere il problema:</p>
    <div>
      <hr style="width:50vw;margin-left: 25vw">
      <div>
        <h5 style="color:red;font-weight: bold;">Soluzione numero 1</h5>
        <p>Rimani su Samsung Browser MA <span style="color:red;font-weight: bold;">cambia il tema in modalità light e clicca su "Vai al sito!"</span></p>
        <img src="alert_dark.png" style="width:90vw;text-align: center;object-fit: cover;"/>
      </div>
      <hr style="width:50vw;margin-left: 25vw">
      <h5 style="color:red;font-weight: bold;">Soluzione numero 2</h5>
      <div>
        <p style="color:red;font-weight: bold;">Cambia semplicemente browser</p>
        <p>(Google, Mozzilla, Opera, Safari, ...)</p>
        <p> per visualizzare correttamente il sito in entrambe le modalità (light/dark)</p>
      </div>
    </div>
    </div>
    <div id="app" v-if="show_page">
     
      <div id="page"></div>
      <FirstPage v-if="this.target_page==='Home' && Object.keys(this.firebase_data).length"/>
      <SecondPage v-if="this.target_page==='Servizi'"/>
      <ThirdPage v-if="this.target_page==='Team'"/>
      <FourthPage v-if="this.target_page==='Eventi'"/>
      <FifthPage v-if="this.target_page==='Contatti'"/>
      <SixthPage v-if="this.target_page==='Prodotti'"/>
      <SeventhPage v-if="this.target_page==='Preferiti'"/>
    </div>
</div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import FirstPage from './components/FirstPage.vue';
import SecondPage from './components/SecondPage.vue';
import ThirdPage from './components/ThirdPage.vue';
import FourthPage from './components/FourthPage.vue';
import FifthPage from './components/FifthPage.vue';
import SixthPage from './components/SixthPage.vue'
import SeventhPage from './components/SeventhPage.vue';
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, logTime } from "firebase/analytics";

import { getFirestore, collection, getDocs, getDoc, doc} from 'firebase/firestore/lite';
import $ from "jquery";

// Follow this pattern to import other Firebase services
// import { } from 'firebase/<service>';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCcxuN_ToTYSmdAK57gGQxgzXt8o-sAtjs",
  authDomain: "hulahoop-58ede.firebaseapp.com",
  projectId: "hulahoop-58ede",
  storageBucket: "hulahoop-58ede.appspot.com",
  messagingSenderId: "1036895608174",
  appId: "1:1036895608174:web:8ebf4e39942d01ba10f57f",
  measurementId: "G-6F6N0QWH4E"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Get a list of cities from your database
async function getData(key) {
  const data_ref = doc(db, 'data', 'data');
  const data_snap = await getDoc(data_ref);
  const data = data_snap.data()
  return data;
}

//DO NOT READ IF ALREADY IN LOCAL DATA
let data = getData('slides').then((result)=>{return JSON.parse(JSON.stringify(result))})
//console.log(data)
  //load firebase data
  


export default {
  name: 'App',
  components: {
    FirstPage,
    SecondPage,
    ThirdPage,
    FourthPage,
    FifthPage,
    SixthPage,
    SeventhPage
  },
  data(){
    return{
      target_page:String,
      firebase_data:Object,
      start:true,
      isMobile:Boolean,
      isSamsungBrowser:Boolean,
      show_page:true,
      analytics_:Event
    }
  },
  beforeMount(){
   this.isSamsungBrowser = navigator.userAgent.match(/SamsungBrowser/i)
   this.isMobile = navigator.userAgent.toLowerCase().match(/mobile/i);

    if (this.isSamsungBrowser){
      //alert("ATTENZIONE:\nHai aperto il sito in Samsung Browser.\nSamsung Browser altera i colori della pagina.\nUsare qualsiasi browser (come Chrome) eccetto Samsung Browser!")
      //this.show_page=false 
     
        this.show_page=false
    

    }

  },
  mounted(){

    this.analytics_ = getAnalytics();
    logEvent(this.analytics_, 'device',{user_agent:navigator.userAgent})
    
    this.isMobile = navigator.userAgent.toLowerCase().match(/mobile/i);
    //console.log("MOBILE",this.isMobile)
   



    //console.log(this.$el.querySelector(".navbar > .navbar-toggler.collapsed"), this.$el.querySelector(".navbar > .navbar-toggler.not-collapsed"))
    this.$el.querySelector("#coin").addEventListener("transitionstart", ()=>{
       this.$el.querySelector("#coin").style.animation="none"

      })
    this.$el.querySelector("#coin").addEventListener("transitionend", ()=>{
      this.$el.querySelector("#coin").style.animation="rotate3d 8s linear infinite"
      this.$el.querySelector("#coin").style.animationPlayState="initial"
    })

    data.then((result)=>{
    this.firebase_data=JSON.parse(JSON.stringify(result))
    this.target_page='Home' //first page
    //("MOUNTED", this.isMobile, this.firebase_data)

        this.$el.querySelector(".navbar > .navbar-toggler").addEventListener('click', ()=>{
        //move coin to left when toggler is not-collapsed
          if (window.innerWidth<990){
        //console.log(this.$el.querySelector(".navbar > .navbar-toggler.collapsed"), this.$el.querySelector(".navbar > .navbar-toggler.not-collapsed"))
        //move left



        if (this.$el.querySelector(".navbar > .navbar-toggler.not-collapsed")===null){
                  if(window.innerWidth<500){
                    this.$el.querySelector("#coin").style.marginLeft="-25vw"

                  }else{
                    this.$el.querySelector("#coin").style.marginLeft="-25vw"

                  }
                  this.$el.querySelector("#coin").style.rotate="-360deg"
                  
                  this.$el.querySelector("#coin").style.transition="all 1s "




                }
        if (this.$el.querySelector(".navbar > .navbar-toggler.collapsed")===null){
                  if(window.innerWidth<500){
                    this.$el.querySelector("#coin").style.marginLeft="0vw"

                  }else{
                    this.$el.querySelector("#coin").style.marginLeft="10vw"

                  }
                  this.$el.querySelector("#coin").style.rotate="360deg"

                  this.$el.querySelector("#coin").style.transition="all 1s"

                    }

          }
          
      })
          //click twice to adjust bootstrap classes
      this.$el.querySelector(".navbar > .navbar-toggler").click()
      setTimeout( ()=>{
        this.$el.querySelector(".navbar > .navbar-toggler").click();
         if (this.isSamsungBrowser) this.$el.querySelector(".navbar > .navbar-toggler").disabled=true
         addEventListener('click',(e)=>{
          try{
            this.track_clicks(e)
          }catch{

          }
         })

        },10 )
    

      //new event listner: clickling on image === clicking on .navbar-toggler
      this.$el.querySelector("#coin").addEventListener("click", ()=>{
        this.$el.querySelector(".navbar > .navbar-toggler").click()
      })

      //this.redirect_on_start()
    })
  
    
  },
  methods: {
    redirect_on_start(){
      if(window.location.href.includes("#")){
        let target_= window.location.href.split("#")[1]
        if (target_!=="Home"){
          this.target_page=target_
        }
      }else{
        
      }
     
    },
    hide_dropdown(){
      this.$el.querySelector("#nav-collapse").style.display="none"
    },

    handle_coin_disabled(){
      this.show_page=true
      this.$el.querySelector(".navbar > .navbar-toggler").disabled=false
    },
    track_page(page_name){
      try{
        //logEvent(this.analytics_, 'page_visited', {page_name:page_name})
        //change also url for easen GA reports
        let new_url=window.location.href.slice(0,window.location.href.lastIndexOf("/"))+"#"+page_name
        new_url.replace("/#",'#')
        //console.log(window.location.href, new_url)
        //window.location.href= new_url
        logEvent(this.analytics_, page_name, {page_name:page_name})
        logEvent(this.analytics_,"screen_view",{page_title:page_name})
        logEvent(this.analytics_,"page_view",{page_title:page_name})



        
      }catch (error){
        console.log("ERROR", error)
      }
    },
    track_clicks(e){
      //log any click on page
      //remember to fix path (in case of path the parent element must be returned)
      let parent_innerHTML=`${e.target.parentNode.innerHTML}`
      let node_innerHTML=`${e.target.innerHTML}`
      if (parent_innerHTML.startsWith("<path")){
        //fix these two
        parent_innerHTML=`${e.target.parentNode.parentNode.parentNode.parentNode.parentNode.innerHTML}`
        node_innerHTML=`${e.target.parentNode.parentNode.parentNode.parentNode.innerHTML}`
      }
      logEvent(this.analytics_, "click", {page_title:this.target_page,node_innerHTML:node_innerHTML, parent_innerHTML: parent_innerHTML })

    }
  
  },
  watch:{
    target_page: function(){
      //console.log(document.querySelectorAll('.header_btn'))
      let header_btns=document.querySelectorAll('.header_btn_active')
      header_btns.forEach((el,i)=>{
        header_btns.item(i).className = header_btns.item(i).className.replace("_active","")
      })

      let active_btn= document.querySelector(`#${this.target_page.toLowerCase()}_btn`)
      active_btn.className= active_btn.className+"_active"

      if(this.start===false && window.innerWidth<=990){    
          let toggleable_div= this.$el.querySelector('.container.navbar-collapse.collapse.show')
        toggleable_div.style.display="none"  
        this.$el.querySelector('.navbar-toggler').click()


      }else{
        this.start=false
      }

      //make dropdown invisible


    },
    firebase_data: function(){
      console.log("FIREBASE DATA LOADED: ",this.firebase_data,  JSON.parse(JSON.stringify(this.firebase_data)))

      //hide empty social card
      let social_els=this.$el.querySelectorAll(".for_social")
      //console.log("SOCIAL ELS", social_els)

      social_els.forEach((d,i)=>{
        if (social_els.item(i).src=""){
          social_els.style.backgroundColor="transparent"
        }
      })
    }
  }
}
</script>


<style>

:root{
  --body_bg:rgba(255, 105, 105,0.6);
  --body_bg_dark:rgba(253, 221, 221, 0.507)

}

body{
  background-color: var(--body_bg) !important;
}

#carousel_cont .carousel-item{
  min-height: 80vh!important;

}


#carousel_cont .carousel-item > img{
  object-fit: fill;
  min-height: 80vh!important;
  max-height: 80vh!important;

}


.slides_cont .carousel-item{
  width:100%;
  max-height: 700px;
  overflow: hidden;
}


.slides_cont .carousel-item > img{
  width: 60%!important;
  margin-left: 20%;
  height:45vw;
  max-height: 30%!important;
  padding:10%
  
}
.header_btn{
  background-color: transparent;
  border-color: transparent ;
  font-family:Ink Free;
  font-size: 25px;
  transition: 0.5s;
  color:var(--body_bg_dark)

}

#coin_cont{
  margin-left: 3%;
  max-height: 132px;
  margin-right: -25%!important;
  margin-top:0%;
  margin-bottom: 1%!important;
  
}

.header_btn:hover{
  color: white;
  font-size: 28px;

  transition: 0.5s;
}



.carousel-control-next, .carousel-control-prev{
  background-color: rgba(255,255,255,0);
  text-align: left;
  transition: 1s;
  color:black;


}

.carousel-control-next:hover, .carousel-control-prev:hover{
  background-color: rgba(255,255,255,0.5);
  text-align: left;
  height: 100%;
  transition: 0.3s;

}


.carousel-control-next-icon, .carousel-control-prev-icon{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAeFBMVEX///8AAAClpaVhYWHc3Nz8/Pz29vbo6Ojw8PCMjIz6+vq0tLRpaWm7u7tHR0dRUVHGxsaUlJSampqsrKx8fHzNzc3h4eE5OTnV1dWFhYUvLy8iIiKfn59ubm7AwMAeHh5jY2MTExNXV1c2NjZBQUEQEBCAgIApKSlVZTOwAAADwklEQVR4nO3ca1PbMBCFYTnBSSCBXLiES2hDgfL//2E7DDW7sWS7gxR11ff5XIY9A0l8VqLOAQAAAAAAAAAAAAAAAAAAAAAAAAD+LzfzzWZ+k3uKdFbb6t3yNvckiSyqxl3uWZJ4rIR97mkSOK+UZe554vuuE1YXuQeK7aQ6tK1zzxTXZSthdT/JPVRUo3bC6qGoiL6E1dM091gRNQl3S5mxoIhNwpH7ISOW83gjErpxkRFlQv14s8o9WiQqobuSEc9zzxaHTujuZMTLzLPFcZDQrWXEUd7Z4jhM6HYy4ibrbHG0EurnuAIKYzuhm8uIVxlni8OT0H2TERf5ZovDl9CtZMRxttni8CZ01zKi8drvT+huZUTbtT+QUHf/57M8w0URSuhuZETLnTiY0E1lxKdZjuGiCCd0M7WGM9uJOxK6yZuMaPVYoyuhq59lRKOduDOhq19kxOtjDxdFd0LnLmREk7V/1Te92k+ZrP0PH594wX+wkBEt1v7p6/vnXceHgVre7I43WTT1bjzedZ7G/JQR18ea66hOZcQCar+H2k/Zr/0+6gDnMfc0SajljfXa76fO+43X/gC1vLFd+0PU8sZ07Q9Sy5u3hLW/Polv2HdWy5unZBHVx28080HfW202XhIFvArNeJSIM/klaZpG+4ZPLMPeOiZiebNNknAdHvGLBtbbycPnlyR5Jd6FR/yiob9zZ5+bjYFvUH9n3jHj1wzepX2+UJIkrFMFHPyUIt4J0uxQE73VDL6uJz/2kwT8/VLfjKPbD96/yEe300QJs1LHw3bPMsLU+9ywZwRbVNMv4rLNgU3pP0H1yG9y+91DPU2ZPMHooW5m2jyF6qZOL8ydJA6o+OoEytpp8PtNvZ5nGnWKaO1E/6Nwdt2z1CfB1p5kpv2DqwsLKVdsaTS3SYOf4OrSicE1ad85vl6vWVx19yVUl79MHlf0JFR92+aRU3dCtcc3elu4M6E6brJ69NuVUB0Zml1ZdCRUhd7uFYxwwlIKfTChKvQWr0L9EUpYTqEPJFRneLYLvT9hSYXem1D13STHL0fkS7gsKaAnYb2VAa0V+rZWwrN7kc/wn1k0DhOqvmuv0HscJJy9ioAGC72HTqj6bqr7MkemEqq+a7LQe8iEqu/uc08Wi0io7h6Wcw+4SbguotB7eP4Xpaqs+/jXvoBmNxY+vhtIFv8upkP7uqrlQu/T+iGaLvReB9fIbBd6PxXReKEPqJtrFvsC2pJfvVovxo8j+3UXAAAAAAAAAAAAAAAAAAAAAAAAAADgH/ILDckel5PMVq4AAAAASUVORK5CYII=")!important;
  background-repeat: no-repeat!important;
  width: 5rem!important;
  height: 5rem!important;
  border-radius: 50%;
}

.carousel-control-prev-icon{
  transform: scaleX(-1);
}
.carousel-control-next-icon{
  transform: scaleX(1);
}

.header_btn_active{
  background-color: transparent;
  border-color: transparent ;
  font-family: Ink Free;
  font-size: 30px;
  color:white;  
  

}




h1,h3,h4{
  font-family: Ink Free;
  font-weight: bolder;
  text-shadow: var(--body_bg) 3px 1px 10px;
}

.nav-link{
  font-size: 25px!important;
}

.carousel-caption{
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 3em;
  color:black!important;
  font-size: 15px;
}

.slides_cont .carousel-caption{
  background-color: rgba(255, 255, 255, 0);
}

.carousel-caption h3{
  margin-top: -1%!important;
  text-shadow: var(--body_bg) 3px 1px 10px;
  font-size: 20px!important;
}




.for_social_sub{
  background-color: var(--bs-danger);
  border-radius: 50%;
  width: 35px;
  text-align: center;
  border: rgb(248, 188, 188) 3px solid;

}

.for_social_sub_empty{
  display: none;
}

.for_social_sub > *> svg > path{
  fill: rgb(248, 188, 188);
}

.card_social_cont{
  display: flex;
    flex-direction: row;;
    width: 50%;
    text-align:justify;
    justify-content: space-evenly;
    position: absolute;
    top:-15px;
    left:25%!important;
    margin-top:-0%;
    font-size:20px;
    z-index: 99999!important;


}

.navbar-toggler.collapsed, .navbar-toggler{
  position:absolute;
  top:0;
  width: 25%;
  right: 0;
  height: 100%;
 
}

.navbar-toggler.not-collapsed{
  height: 95%;
}


.carousel-item > img{
    width: 100%;
    max-height: 800px;
    
  
}

.carousel-item{
  text-align: center;
}

#team_btn::before, #prodotti_btn::before, #servizi_btn::before{
  content:"";
  border:1px solid var(--body_bg);
  height: 25%;
  width:  0%;
  margin-right: 15%;
}



#eventi_btn,#preferiti_btn,#contatti_btn{
  margin-left: 2%;
}
@keyframes rotate3d {
            0% {
                transform: perspective(1000px) rotateY(360deg);
            }

            100% {
                transform: perspective(1000px) rotateY(0deg);
            }
        }

#coin{
  animation: rotate3d 8s linear infinite;
  margin-bottom: -5%!important;
  margin-left: -40%;
  background: rgba(255,255,255,0.7);
  border-radius: 50%;
  border: var(--body_bg) 25px solid;
  width: 550px;
  position: relative;
  z-index:1

}

#home_btn{
  margin-left: 0%;
}



@media only screen and (min-width: 990px) {

  #header_pages_cont{
  display: flex;
  flex-direction: row;
  
}

  #header_social_cont{
  display: flex;
  flex-direction: row;
  position: absolute;
  right:25px;
}



.header_title{
  display: none;
 }

 .arrow{
  display: block;
  background-color: rgba(255,255,255,0.5);
 }



 #coin{
  animation: rotate3d 8s linear infinite;
  margin-top: -38%!important;
  margin-left: -40%!important;
  background: rgba(255,255,255,0.7);
  border-radius: 50%;
  border: var(--body_bg) 25px solid;
  scale: 0.2 !important;
  object-fit: contain;
  object-position: center;
  box-sizing:content-box; 
}

}

@media only screen and (max-width: 990px) {
  #header_pages_cont{
  display: flex;
  flex-direction: column;
}
#header_social_cont{
  width: 50%;
  position: absolute;
  display: flex;
  flex-direction: row;
  text-align: justify;
  justify-content: space-evenly;
  left: 30%;
  bottom:0

}
.header_title{
  display: none;
  font-family: Ink Free;
  font-size: 35px;
  font-weight: bolder;
  text-align: center;
 }
 .arrow{
  display: none;
 }

 #nav-collapse{
  margin-left: 43%;
  margin-bottom:50px;
  margin-top:-15%;
 }

 #coin{
  margin-left: 20%;
  transform:scale(1);
}

#header_social_cont{
  background-color: var(--body_bg);
  width: 100%;

}

* > #header_social_cont{
  width: 100%!important;
  left:0px !important
}


}




@media only screen and (max-width: 990px) {
  #nav-collapse{
  margin-left: 35%;
  margin-bottom:50px;
  margin-top:-15%;

 }
 .card_social_cont{
  margin-top: 3%!important;
 }
 .for_social_sub{
  transform:scale(0.8);
 }

 p{
  margin-top: 0px!important;
 }



 #coin{
  scale: 0.8;
  border-width: 7px;
  animation: rotate3d 8s linear infinite;
  width: 150px;
}


@media(orientation:portrait){
  #coin_cont{
  margin-left: 32%!important;
  width: 50%!important;
 }
 .navbar-toggler{
  display: none!important;
 }
 .navbar-collapse{
  margin-left: 35%!important;
 }
 h3{
  margin-top: 5%!important;
  font-size:1rem!important
}
.card_social_cont{
  top:-25px;
}

.slides_cont .carousel-item{
  width:100%;
  height: 500px;
  overflow: hidden;
  background-color: rgba(255,255,255,1)!important;
}


.slides_cont .carousel-item > img{
  width: 500px!important;
  margin-left:0%;
  height: 70%!important;
  max-height: 700px!important;
  margin-top: 30%;
  
}
#team_btn::before, #prodotti_btn::before, #servizi_btn::before{
  position:absolute;
  content:"";
  border:1px solid var(--body_bg);
  height: 0%;
  width: 50%;
  left:25vw;
  background-color:var(--body_bg)

}

#navbar_{
  padding-bottom: 20px;
}
.pseudo_table{
  margin-left:7%!important;
  
}

#carousel_cont .carousel-item{
  min-height: 50vh!important;
  background-color: white!important;

}




#carousel_cont .carousel-item > img{
  object-fit: contain;
  min-height: 50vh!important;
  max-height: 50vh!important;

}

.carousel-text-cont{
  height: 120px!important;
  background-color: rgba(255,255,255,0);
}

}
@media(orientation:landscape){
  #coin_cont{
  margin-left: 32%!important;


 }
 .navbar-toggler{
  display: none!important;
 }
 .navbar-collapse{
  margin-left: 42%!important;
 }

 h3{
  margin-top: 2%!important;
}
.card_social_cont{
  top:-10%;
}

.slides_cont .carousel-item{
  width:100%;
  max-height:700px !important;
  overflow: hidden;
}


.slides_cont .carousel-item > img{
  width: 60%!important;
  min-height: 300px;
  
  
}
#navbar_{
  padding-bottom: 20px;
}

.pseudo_table{
  margin-left: 35%!important;
}

}



 #team_btn::before, #prodotti_btn::before, #servizi_btn::before{
  position:absolute;
  content:"";
  border:1px solid var(--body_bg);
  height: 0%;
  width: 50%;
  left:25vw;
  background-color: var(--body_bg);
}


}
.navbar{
  display: flex;
  flex-direction: row;
  width: 100%!important;
}

.pseudo_table{
  margin-left: 40%;
}

</style>

